import { IFormattedSearch } from 'components/SearchBar/SearchOption/types/IFormattedSearch';
import { SearchOptionLabelElement } from 'components/SearchBar/SearchOption/types/SearchOptionLabelElement';

export const searchOptionLabelElements = (option: IFormattedSearch): SearchOptionLabelElement[] => [
  { label: 'Display Unit ID', value: option.displayUnitId },
  { label: 'Broadsign Frame ID', value: option.broadsignFrameId },
];
